import React from 'react';
import { CalendarCheck, Layers3, ShieldCheck, Mail, Phone } from 'lucide-react';

const AboutCompany = () => {
  return (
    <section id="o-firmie" className="bg-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20">
        <div className="flex items-center gap-3 mb-10">
          <span className="block w-7 h-[2px] bg-[#e30613]" />
          <h3 className="font-bold tracking-[0.22em] text-[13px] text-[#1c1c1c]">O FIRMIE</h3>
        </div>

        <div className="grid lg:grid-cols-[1fr_320px] gap-12 lg:gap-16">
          {/* Long-form copy */}
          <div className="space-y-6 text-[14.5px] md:text-[15px] leading-[1.75] text-[#2a2a2a] max-w-[760px]">
            <p>
              Od <span className="font-semibold text-[#1c1c1c]">2018 roku</span> specjalizujemy
              się w realizacji dachów płaskich i tarasów w oparciu o sprawdzone systemy
              hydroizolacyjne. Każdy projekt analizujemy indywidualnie — z uwzględnieniem
              konstrukcji, odwodnienia oraz detali, które w praktyce decydują o szczelności
              i trwałości całego układu.
            </p>
            <p>
              Nie stosujemy rozwiązań przypadkowych. Pracujemy systemowo, ograniczając ryzyko
              na etapie projektu i wykonania: membrany zamawiane pod wymiar pozwalają
              zminimalizować ilość łączeń, systemy klejone zapewniają współpracę z podłożem,
              a newralgiczne strefy — attyki, wpusty, przejścia — są dopracowane z pełną
              precyzją.
            </p>
            <p>
              Korzystamy wyłącznie z materiałów renomowanych producentów membran typu
              <span className="font-semibold text-[#1c1c1c]"> EPDM, PVC, TPO</span>, w tym
              systemów <span className="font-semibold text-[#1c1c1c]">Hertalan</span> i
              <span className="font-semibold text-[#1c1c1c]"> Resitrix</span>. Dobór technologii
              zawsze wynika z warunków konkretnej inwestycji, nie z przyzwyczajeń.
            </p>
            <p>
              To podejście jest skierowane do inwestorów, którzy oczekują trwałości i spokoju
              na lata — bez powrotów do tematu po kilku sezonach. Jeżeli zależy Państwu na
              rozwiązaniu dopracowanym w każdym detalu, zapraszamy do kontaktu. Na podstawie
              projektu lub dokumentacji przedstawimy konkretne, uzasadnione technicznie
              rozwiązanie dopasowane do inwestycji.
            </p>
          </div>

          {/* Side facts panel */}
          <aside className="lg:sticky lg:top-28 self-start">
            <div className="bg-[#0b0b0b] text-white p-7 lg:p-8 relative overflow-hidden">
              <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#e30613] to-transparent" />

              <h4 className="text-[11px] font-bold tracking-[0.28em] text-white/60 mb-6">DANE FIRMY</h4>

              <div className="space-y-5">
                <div className="flex items-start gap-3">
                  <CalendarCheck size={18} className="text-[#e30613] mt-0.5 shrink-0" strokeWidth={1.6} />
                  <div>
                    <p className="text-[11px] tracking-[0.18em] text-white/55 uppercase">Na rynku od</p>
                    <p className="text-[15px] font-bold mt-0.5">2018</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <Layers3 size={18} className="text-[#e30613] mt-0.5 shrink-0" strokeWidth={1.6} />
                  <div>
                    <p className="text-[11px] tracking-[0.18em] text-white/55 uppercase">Systemy</p>
                    <p className="text-[13.5px] mt-0.5 leading-relaxed">EPDM · TPO · PVC<br />Hertalan · Resitrix</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <ShieldCheck size={18} className="text-[#e30613] mt-0.5 shrink-0" strokeWidth={1.6} />
                  <div>
                    <p className="text-[11px] tracking-[0.18em] text-white/55 uppercase">Specjalizacja</p>
                    <p className="text-[13.5px] mt-0.5 leading-relaxed">Dachy płaskie, tarasy, hydroizolacje</p>
                  </div>
                </div>
              </div>

              <div className="my-7 h-px bg-white/10" />

              <h4 className="text-[11px] font-bold tracking-[0.28em] text-white/60 mb-5">KONTAKT</h4>

              <div className="space-y-4">
                <a href="tel:+48797219803" className="flex items-center gap-3 group">
                  <Phone size={16} className="text-[#e30613] shrink-0" strokeWidth={1.6} />
                  <span className="text-[14px] font-semibold tracking-wide text-white group-hover:text-[#e30613] transition-colors duration-200">
                    +48 797 219 803
                  </span>
                </a>
                <a href="mailto:kontakt@lstoit.pl" className="flex items-center gap-3 group">
                  <Mail size={16} className="text-[#e30613] shrink-0" strokeWidth={1.6} />
                  <span className="text-[14px] font-semibold text-white group-hover:text-[#e30613] transition-colors duration-200">
                    kontakt@lstoit.pl
                  </span>
                </a>
              </div>

              <div className="my-7 h-px bg-white/10" />

              <h4 className="text-[11px] font-bold tracking-[0.28em] text-white/60 mb-4">DANE REJESTROWE</h4>
              <div className="space-y-1.5 text-[12.5px] text-white/75">
                <p className="text-white font-semibold tracking-wide">LE SEPTIEME TOIT</p>
                <p><span className="text-white/50">NIP:</span> 9241851371</p>
                <p><span className="text-white/50">REGON:</span> 369715569</p>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
};

export default AboutCompany;
